"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

const SOVENDUS_TOKEN_KEY = "sovReqToken";

/**
 * Captures the sovReqToken from URL and stores in localStorage.
 * Following Sovendus documentation for partner tracking.
 */
export function SovendusTokenCapture() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const token = searchParams.get(SOVENDUS_TOKEN_KEY);
    if (token) {
      localStorage.setItem(SOVENDUS_TOKEN_KEY, token);

    }
  }, [ searchParams ]);

  return null;
}
